<script>
  import { setContext, onMount } from 'svelte';
  import anime from 'animejs/lib/anime.es.js';

  export let duration = 1000;
  export let easing = "linear";
  export let progress = null;


  let timeline;

  export const play = () => {
    timeline.play();
  };

  export const reset = () => {
    timeline.seek(0);
  };

  function fixEasing(e) {
    return e.replace("-b", "B").replace("-i", "I").replace("-o", "O");
  }

  $: progress !== null && timeline && timeline.seek(progress * duration);

  setContext("getTimeline", () => {
    return timeline;
  });
  setContext("getDuration", () => duration);
  setContext("getEasing", () => easing);

  onMount(() => {
    timeline = anime.timeline({
      easing: fixEasing(easing),
      duration: duration,
      loop: false,
      autoplay: false,
    });


    setTimeout(() => {
      if (progress !== null) timeline.seek(progress * duration);
    });
  });


</script>

<div class="animation anim-c">
  <slot></slot>
</div>

